import { ListSubheader, Stack, styled } from "@mui/material";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import * as React from "react";
import { COLOR_CONSTANTS } from "../../../helpers/Colors";
import { convertToTitleCase } from "../../../helpers/Utils";
import { orderEntries, useStatusParamFilter } from "../hooks/useStatusParamFilter";

const CustomListItem = styled(ListItemButton)`
  &&.Mui-selected {
    color: ${COLOR_CONSTANTS["on-primary/variant"]};
    background-color: ${COLOR_CONSTANTS["primary/variant"]};
  }
`;

/** Desktop status sidebar — same URL-param semantics as StatusChipStrip via useStatusParamFilter. */
export default function OrderFilter({
  data,
  label,
  defaultSelect,
  paramName = "filter_status",
}) {
  const { selected: selectedIndex, select } = useStatusParamFilter({ defaultSelect, paramName });
  const handleListItemClick = (event, id) => select(id);

  return (
    <Box
      sx={{
        width: 250,
        bgcolor: "background.paper",
        borderRadius: "8px",
        maxHeight: "calc(100vh - 180px)",
        overflowY: "auto",
      }}
    >
      <List component="nav" aria-label="secondary mailbox folder">
        <ListSubheader>{label}</ListSubheader>
        <Divider />

        {orderEntries(data).map(([filter, count]) => (
          <CustomListItem
            key={filter}
            selected={selectedIndex === filter}
            onClick={(event) => handleListItemClick(event, filter)}
          >
            <ListItemText
              primary={
                <Stack
                  direction={"row"}
                  justifyContent={"space-between"}
                  alignItems={"center"}
                >
                  <div>{convertToTitleCase(filter)}</div>
                  <div>{count}</div>
                </Stack>
              }
            />
          </CustomListItem>
        ))}
      </List>
    </Box>
  );
}
